// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1185":"649a4632","2322":"649a4632","3562":"649a4632","6380":"649a4632","6674":"649a4632","6845":"649a4632","9440":"649a4632"}[chunkId] + ".chunk.css";
};